'use strict';

import angular from 'angular';
import routes from './admin.routes';
import AdminController from './admin.controller';

export default angular.module('bfastCaptureManagerApp.admin', ['bfastCaptureManagerApp.auth',
  'ui.router'
])
  .config(routes)
  .controller('AdminController', AdminController)
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/index.js